import { render } from "./VersionRegistryComponent.vue?vue&type=template&id=5d3501af&scoped=true"
import script from "./VersionRegistryComponent.vue?vue&type=script&lang=js"
export * from "./VersionRegistryComponent.vue?vue&type=script&lang=js"

import "./VersionRegistryComponent.vue?vue&type=style&index=0&id=5d3501af&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3501af"]])

export default __exports__